
export const colors = {
  darkGreen: '#438C91',
  lightBlue: '#9CC8E9',
  green: '#54964B',
  lightGreen: '#88C67A',
  yellow: '#FFC465',
  red: '#C67A7A',
  pink: '#C67AAC',
  purple: '#9D377A',
  darkBlue: '#484C88',
  orange: '#E38C40',
  altBlue: '#5A9BA6'
}
